import React, { forwardRef } from 'react'

export const HotspotText = forwardRef((props, ref) => {

    return (
        <div ref={ref} className={`hotspot-text ${props.hotspot.textPosition} ${props.hotspot.id} ${props.className}`}>
            {props.hotspot.pretty}
        </div>
    )
})